import { createAction, props } from '@ngrx/store';
import { UserGroup } from '../user-groups.model';

export const setUserGroups = createAction(
  '[User Groups] list',
  props<{ userGroups: UserGroup[] }>()
);

export const addUserGroup = createAction('[User Groups] add', props<{ userGroup: UserGroup }>());

export const updateUserGroup = createAction(
  '[User Groups] update',
  props<{ userGroup: UserGroup }>()
);

export const deleteUserGroups = createAction('[User Groups] delete', props<{ ids: string[] }>());

export const clearUserGroups = createAction('[User Groups] clear');
